"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
function screenDetails() {
    return new Promise(function (resolve) {
        resolve({
            'is_touchscreen': navigator.maxTouchPoints > 0,
            'maxTouchPoints': navigator.maxTouchPoints,
            'colorDepth': screen.colorDepth,
            'mediaMatches': matchMedias(),
        });
    });
}
function matchMedias() {
    var results = [];
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_media_queries/Using_media_queries
     */
    var mediaQueries = {
        'prefers-contrast': ['high', 'more', 'low', 'less', 'forced', 'no-preference'],
        'any-hover': ['hover', 'none'],
        'any-pointer': ['none', 'coarse', 'fine'],
        'pointer': ['none', 'coarse', 'fine'],
        'hover': ['hover', 'none'],
        'update': ['fast', 'slow'],
        'color': ['8', '16', '256'],
        'inverted-colors': ['inverted', 'none'],
        'prefers-reduced-motion': ['reduce', 'no-preference'],
        'prefers-reduced-transparency': ['reduce', 'no-preference'],
        'scripting': ['none', 'initial-only', 'enabled'],
        'forced-colors': ['active', 'none'],
        'display-mode': ['fullscreen', 'standalone', 'minimal-ui', 'browser'],
        'prefers-color-scheme': ['dark', 'light', 'no-preference'],
    };
    Object.keys(mediaQueries).forEach(function (key) {
        mediaQueries[key].forEach(function (value) {
            if (matchMedia("(".concat(key, ": ").concat(value, ")")).matches)
                results.push("".concat(key, ": ").concat(value));
        });
    });
    return results;
}
(0, factory_1.includeComponent)('screen', screenDetails);
//# sourceMappingURL=screen.js.map